import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
/**
 * Phase 4 Task 4 — emitted by the worker ACD handler when an inbound
 * caller is enqueued (no agent available). Consumed by the WS gateway
 * to push queue position updates to the browser.
 */
export const QueueEnteredEventSchema = z.object({
    type: z.literal('queue.entered'),
    ...baseEventFields,
    callId: uuidSchema,
    // queueId is a free-form identifier (slug, UUID, or the literal
    // 'default' fallback) — keep it as a non-empty string so the ACD
    // handler's fallback queue id parses cleanly.
    queueId: z.string().min(1),
    callerCLI: z.string().min(1),
    enqueuedAt: z.string().datetime(),
    position: z.number().int().nonnegative(),
});
/**
 * Emitted when a caller hangs up while still waiting in queue (Phase 4
 * Task 5+ wires the producer; schema lives here so consumers can be
 * authored ahead of time).
 */
export const QueueAbandonedEventSchema = z.object({
    type: z.literal('queue.abandoned'),
    ...baseEventFields,
    callId: uuidSchema,
    queueId: z.string().min(1),
    waitTimeMs: z.number().int().nonnegative(),
});
export const QueueCancelReasonSchema = z.enum([
    'TIMEOUT',
    'NO_AGENT_TIMEOUT',
    'BREAK_OUT',
    'EXIT_WITH_KEY',
]);
export const QueueTimeoutEventSchema = z.object({
    type: z.literal('queue.timeout'),
    ...baseEventFields,
    callId: uuidSchema,
    queueId: z.string().min(1),
    waitTimeMs: z.number().int().nonnegative(),
    cancelReason: QueueCancelReasonSchema,
});
//# sourceMappingURL=queue.js.map